'use client';
import { useCallback } from 'react';
import { useBreakpoint } from '../useBreakpoint';
import { IN_APP, PAGE_BREAKPOINTS } from '../../constants/commonConstants';
import { getInAppSessionStorage, setInAppSessionStorage, removeInAppSessionStorage } from './utils';
export const useInAppSignOut = () => {
    const search = typeof window !== 'undefined' ? window.location.search : '';
    const searchParams = new URLSearchParams(search);
    const isTabletAndMobileLayout = !useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
    const inAppQueryParam = searchParams.get(IN_APP);
    const setInAppCookie = useCallback((isLoggedIn) => {
        if (isLoggedIn && inAppQueryParam && isTabletAndMobileLayout) {
            setInAppSessionStorage(IN_APP, inAppQueryParam);
        }
    }, [inAppQueryParam, isTabletAndMobileLayout]);
    const getInAppCookie = useCallback(() => isTabletAndMobileLayout && Boolean(getInAppSessionStorage(IN_APP)), [isTabletAndMobileLayout]);
    const removeInAppCookie = useCallback(() => removeInAppSessionStorage(IN_APP), []);
    return { setInAppCookie, getInAppCookie, removeInAppCookie };
};
